import React from 'react';
import {CircularProgress, Stack} from "@mui/joy";

// components
import BaseApi from "../../utils/BaseApi";
import UserSubscriberContext from "../../context/UserSubscriberContext";
import CallCard from "./CallCard";
import Chip from "@mui/joy/Chip";


class CallsListModalInner extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            calls: null,
        };
    }

    async componentDidMount() {
        await this.retrieveCalls();
    }

    async retrieveCalls() {
        const url = `sunsim_call/`;
        const params = {
            phone: this.props.phone,
            page_size: 10000,
        };
        const api = new BaseApi();
        let response = await api.get(
            url,
            params
        );
        await this.setState(
            {
                calls: response.data.results
            }
        );
    }

    render() {
        if (!this.state.calls){
            return (<CircularProgress/>)
        }
        return(
            <Stack
                spacing={2}
            >
                {
                    !this.state.calls.length?
                        <Chip
                            color={'warning'}
                        >
                            Список пуст
                        </Chip>:null
                }
                {
                    this.state.calls.map(c => (
                        <CallCard
                            id={'CalLCard'+c.id}
                            call={c}
                        />
                    ))
                }
            </Stack>
        )
    }
}

export default CallsListModalInner